module.exports = __webpack_public_path__ + "static/media/play-button.af13ec5c.png";